import React from 'react';
import {
  FormControl as MuiFormControl,
  Select as MuiSelect,
  InputLabel as MuiInputLabel,
  MenuItem as MuiMenuItem,
} from '@mui/material';

function ComboBasic({
  items = [], // object array
  wrapSx, // object
  color, // 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  size, // 'medium' | 'small'
  fullWidth = false, // bool
  required = false, // bool
  disabled = false, // bool
  autoWidth = false, // bool
  classes, // node
  defaultOpen = false, // bool
  displayEmpty = false, // bool
  IconComponent, // elementType
  id = '', // string
  input, // element
  inputProps, // object
  name, // node
  nameId = '', // string
  MenuProps, // object
  multiple, // object
  native = false, // bool
  open, // bool
  SelectDisplayProps, // object
  sx, // object
  value = '', // any
  variant = 'outlined', // 'filled' | 'outlined' | 'standard'
  renderValue,
  onOpen = (e) => {},
  onClose = (e) => {},
  onChange = (e) => {},
}) {
  const ChangeSelect = (e) => {
    onChange(e.target.value);
  };

  const OpenSelect = (e) => {
    onOpen(e);
  };

  const CloseSelect = (e) => {
    onClose(e);
  };

  return (
    <MuiFormControl
      sx={wrapSx}
      color={color}
      size={size}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
    >
      <MuiInputLabel>{name}</MuiInputLabel>
      <MuiSelect
        autoWidth={autoWidth}
        classes={classes}
        defaultOpen={defaultOpen}
        displayEmpty={displayEmpty}
        IconComponent={IconComponent}
        id={id}
        input={input}
        inputProps={inputProps}
        label={name}
        labelId={nameId}
        MenuProps={MenuProps}
        multiple={multiple}
        native={native}
        open={open}
        SelectDisplayProps={SelectDisplayProps}
        sx={sx}
        value={value}
        variant={variant}
        renderValue={renderValue}
        onOpen={OpenSelect}
        onClose={CloseSelect}
        onChange={ChangeSelect}
      >
        {items.map((item, index) => {
          return (
            <MuiMenuItem key={index} value={item.value}>
              {item.name}
            </MuiMenuItem>
          );
        })}
      </MuiSelect>
    </MuiFormControl>
  );
}

export default React.memo(ComboBasic);
